export const setCheckboxValue = (checkboxData, event) => {
    const temp = copyArray(checkboxData);
    temp.forEach(filterCheckbox => {
        if (filterCheckbox.label === event.target.name) {
            filterCheckbox.value = event.target.checked
        }
    })
    return temp
}

export const searchCheckboxValue = (checkboxArray, type) => {
    const tempArray = copyArray(checkboxArray)
    let flag = false;
    for (let i = 0; i < tempArray.length; i++) {
        if (tempArray[i].label === type) {
            flag = tempArray[i].value
            break;
        }
    }
    return flag
}
export const copyArray = (data) => {
    let tempLevelOne = JSON.stringify(data);
    return JSON.parse(tempLevelOne)
}